import { Button, Nav, Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../Context/GlobalStateContext";
import { getLandingPath, hasModuleAccess, isAdminCompany, MODULES } from "../Utils/modulos";

const NavBar = () => {
  const navigation = useNavigate();
  const { userData, setUserData } = useGlobalState();
  const geocercasActivas = hasModuleAccess(userData, MODULES.GEOCERCAS);
  const pausasActivas = hasModuleAccess(userData, MODULES.PAUSAS);
  const cinturonesActivos = hasModuleAccess(userData, MODULES.CINTURONES);
  const adminActiva = isAdminCompany(userData);

  const handleEliminar = () => {
    localStorage.removeItem("empresaid");
    localStorage.removeItem("empresaNombre");
    localStorage.removeItem("userData");
    setUserData({
      empresaId: "",
      empresaNombre: "",
      empresaUsuario: "",
      moduloGeocercas: true,
      moduloPausas: false,
      moduloCinturones: false,
    });
    navigation("/", { replace: true });
  }
  return (
      <Navbar bg="dark" variant="dark" expand="lg" fixed="top" className="app-navbar px-3 py-2">
      <Navbar.Brand style={{ cursor: "pointer" }} onClick={() => navigation(getLandingPath(userData))}>Ruta Segura</Navbar.Brand>
      <Navbar.Toggle aria-controls="main-navbar-nav" />
      <Navbar.Collapse id="main-navbar-nav" className="justify-content-between gap-3">
        <Nav className="me-auto">
          {cinturonesActivos && (
            <Nav.Link onClick={() => navigation("/cinturones-seguridad")}>Cinturones de seguridad</Nav.Link>
          )}
          {geocercasActivas && (
            <>
              <Nav.Link onClick={() => navigation("/rutas")} >Rutas</Nav.Link>
              <Nav.Link onClick={() => navigation("/galeria")}>Galería de Cercas</Nav.Link>
            </>
          )}
          {geocercasActivas && (
            <Nav.Link onClick={() => navigation("/dispositivos")}>Dispositivos</Nav.Link>
          )}
          {pausasActivas && (
            <>
              <Nav.Link onClick={() => navigation("/pausas-activas")}>
                Pausas
              </Nav.Link>
            </>
          )}
          {adminActiva && (
            <>
              <Nav.Link onClick={() => navigation("/protocolos-dispositivo")}>
                Protocolos
              </Nav.Link>
              <Nav.Link onClick={() => navigation("/panel-administrador")}>
                Administracion
              </Nav.Link>
            </>
          )}
        </Nav>
        <Button onClick={() => handleEliminar()} variant="outline-light" style={{ width: "100%", maxWidth: "220px" }}>
          Cerrar Sesión
        </Button>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavBar;
